export const releaseOpsToHuman = (op_name) => {
    switch (op_name) {
        case 'fake_workflow':
            return 'GHA Workflow (Fake)';
        case 'gha_workflow':
            return 'GHA Workflow';
        case 'upgrade':
            return 'Upgrade cluster';
        case 'reindex':
            return 'Reindex';
        case 'redeploy_pipelines':
            return 'Redeploy pipelines';
        case 'omd_e2e':
            return 'OpenMetadata Deployment E2E Tests';
        default:
            return op_name;
    }
}

export const name_for_op = (op) => {
    switch (op) {
        case 'aut_psql':
            return 'AUT (Postgres)';
        case 'aut_mysql':
            return 'AUT (MySQL)';
        case 'aut_psql_v2':
            return 'AUT (Postgres V2)';
        case 'aut_mysql_v2':
            return 'AUT (MySQL V2)';
        case 'aut_psql_kind':
            return 'AUT (Postgres · kind)';
        case 'aut_mysql_kind':
            return 'AUT (MySQL · kind)';
        case 'reindex':
            return 'Reindex';
        case 'redeploy_pipelines':
            return 'Redeploy pipelines';
        case 'om_branch':
            return 'OpenMetadata branch';
        case 'collate_branch':
            return 'Collate branch';
        case 'om_helm':
            return 'OpenMetadata Helm branch';
        case 'hybrid_runner_branch':
            return 'Hybrid Runner branch';
        case 'hybrid_helm_branch':
            return 'Hybrid Helm branch';
        case 'terraform_deploy_branch':
            return 'Terraform deployment branch';
        case 'terraform_aws_module_branch':
            return 'Terraform AWS Module Branch';
        case 'collate_ai_branch':
            return 'Collate AI Branch';
        case 'changelog':
            return 'Changelog';
        case 'sso_login':
            return 'SSO Login (Playwright)';
        case 'ai_platform_unit_tests':
            return 'AI Platform Unit Tests';
        case 'ai_platform_tests':
            return 'AI Platform Tests';
        case 'construct_build':
            return 'Construct Build';
        case 'construct_tests':
            return 'Construct Tests';
        case 'construct_image':
            return 'Construct Image';
        case 'askcollate_e2e':
            return 'AskCollate E2E';
        case 'java_it_search':
            return 'Java IT (Search)';
        case 'build_docker':
            return 'Build Docker images';
        case 'aut':
            return 'Run AUTs';
        case 'argo_test':
            return 'Deploy to test-argo';
        case 'vulnerability_scan_collate':
            return 'Vuln Scan (Collate)';
        case 'vulnerability_scan_hybrid':
            return 'Vuln Scan (Hybrid Runner)';
        case 'vulnerability_scan_openmetadata':
            return 'Vuln Scan (OpenMetadata)';
        case 'vulnerability_scan_collate_ingestion':
            return 'Vuln Scan (Collate Ingestion)';
        case 'vulnerability_scan_collate_snyk':
            return 'Vuln Scan (Collate · Snyk)';
        case 'vulnerability_scan_hybrid_snyk':
            return 'Vuln Scan (Hybrid Runner · Snyk)';
        case 'vulnerability_scan_ai_platform':
            return 'Vuln Scan (AI Platform)';
        case 'ai_platform_security_scan':
            return 'Vuln Scan (AI Platform · Snyk)';
        case 'vulnerability_scan_construct':
            return 'Vuln Scan (Construct)';
        case 'vulnerability_scan_construct_snyk':
            return 'Vuln Scan (Construct · Snyk)';
        case 'omd_mysql':
            return 'OMD E2E (MySQL)';
        case 'omd_postgresql':
            return 'OMD E2E (Postgres)';
        default:
            break;
    }
    if (!op) return '';
    if (op.startsWith('deploy_')) {
        return 'Deploy to ' + op.slice(7);
    }
    return op;
}
